import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { uiActions } from '../../store';

import styles from './TopMenu.module.css';
import logo from './assets/logo.svg'
import closeIcon from './assets/close.svg';
import openIcon from './assets/open.svg';

export default function TopMenu({ extended }) {

    // Holds the mobile menu open/closed status
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const dispatch = useDispatch();

    // Update mobile menu status on the hamburger icon click
    const handleMenuTriggerClick = function () {
        setIsMobileMenuOpen(status => !status);
    }

    const openSendByEmailModal = function () {
        dispatch(uiActions.setEmailModalActive(true));
    }

    const openMoreInfoModal = function () {
        dispatch(uiActions.setMoreInfoModalStatus(true));
    }

    const handlePrintClick = function(){
        let saveData = document.getElementById("chamViz").getSaveData();
        let url = "/print.aspx?specifier=Demo\\Cambridge_Homes\\Kitchen&sel="+saveData.sel+"&ImageSel="+saveData.sel;
        window.open(url, "_blank"); // Opens the URL in a new tab
    }

    return (
        <section className={styles.topMenu}>
            <nav aria-label="Main Navigation">
                <ul className={!isMobileMenuOpen ? styles.closed : ''}>

                    <li className={styles.logo}>
                        <Link to="/" aria-label="Home">
                            <img src={logo} width="265" height="43" alt="Company Logo" />
                        </Link>
                    </li>

                    <li className={styles.menuTrigger}>
                        <button onClick={handleMenuTriggerClick} aria-expanded={isMobileMenuOpen} aria-controls="main-menu">
                            <span aria-hidden="true">
                                {!isMobileMenuOpen && <img src={openIcon} alt='open icon' />}
                                {isMobileMenuOpen && <img src={closeIcon} alt='close icon' />}
                            </span>
                        </button>
                    </li>

                    <li>
                        <Link to="/">Start Over</Link>
                    </li>
                    <li>
                        <button onClick={handlePrintClick} aria-label="print">Print</button>
                    </li>
                    <li>
                        <button onClick={openSendByEmailModal}>Send By Email</button>
                    </li>
                    <li>
                        <button onClick={openMoreInfoModal} className={styles.moreInfo}>Get More Information</button>
                    </li>

                </ul>
            </nav>
        </section>
    );
}

